import { defineFilterSpec, multiField, text } from '@/lib/api/filter-spec';

import type { ProductsReportFilterFormValues, ProductsReportListFilters } from './types';

/** Single declaration of the Products report filters, shared by api / drawer / page. All three
 *  are multi-selects, so all three join to comma strings on the wire — matching
 *  `ProductsReportQuery` in `greenway_api`, whose `customerIds` / `productType` /
 *  `subscriptionStatus` are all arrays. Note `productType` is **singular on the wire** but takes a
 *  list; that is the backend's spelling, not a typo.
 *
 *  `search` is declared so `toListQuery` emits it too — the same object feeds the DataTable request
 *  and the export params, and the export must carry the search as well as the filter. */
const spec = defineFilterSpec<ProductsReportListFilters, ProductsReportFilterFormValues>([
  text('search'),
  multiField('customerIds'),
  multiField('productType'),
  multiField('subscriptionStatus'),
]);

export const toListQuery = spec.toListQuery;
export const toDefaults = spec.toDefaults;
export const toFilters = spec.toFilters;
export const hasActiveFilters = spec.hasActiveFilters;
